import React from 'react';

interface AddressObject {
  street?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
}

interface AddressDisplayProps {
  // Option 1: Pass an address object
  address?: AddressObject;
  
  // Option 2: Pass individual address fields
  street?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
  
  // Optional styling
  className?: string;
}

export const AddressDisplay: React.FC<AddressDisplayProps> = ({
  address,
  street,
  city,
  state,
  postcode,
  country,
  className
}) => {
  // Use address object if provided, otherwise use individual fields
  const addressStreet = address?.street || street;
  const addressCity = address?.city || city;
  const addressState = address?.state || state;
  const addressPostcode = address?.postcode || postcode;
  const addressCountry = address?.country || country;

  // Format address components
  const getFormattedAddress = () => {
    const addressLines = [];
    
    if (addressStreet) {
      addressLines.push(addressStreet);
    }
    
    const cityStatePostcode = [addressCity, addressState, addressPostcode]
      .filter(Boolean)
      .join(', ');
    if (cityStatePostcode) {
      addressLines.push(cityStatePostcode);
    }
    
    if (addressCountry) {
      addressLines.push(addressCountry);
    }
    
    return addressLines.length > 0 ? (
      <div className={className}>
        {addressLines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    ) : null;
  };

  return getFormattedAddress();
};
